import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory, Link } from 'react-router';
import { localize } from 'react-localize-redux';

import './SideBar.css';

import { List, ListItem } from 'material-ui/List';
import { MdKeyboardArrowDown as DownArrow } from 'react-icons/md';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import FlatButton from 'material-ui/FlatButton';

import { toggleMobileMenu } from 'actions/navigationActions';
import LandlordLogo from 'components/shared/LandlordLogo';
import PoweredByYuhu from 'components/shared/PoweredByYuhu';

import { AccentColor } from 'helpers/AccentColorHelper';
import { authorizedRoute } from 'helpers/permissionsHelper';
import { colors } from 'helpers/ColorHelper';

const NavLinkItem = connect(
  (store) => {
    return {
      mobileMenuOpen: store.navigation.mobileMenuOpen,
      userPermissions: store.userTypes.permissions,
    };
  },
  { toggleMobileMenu }
)(
  class NavLinkItem extends Component {
    render() {
      if (!authorizedRoute(this.props.to, this.props.userPermissions)) return null;

      const listItemStyle = {
        paddingLeft: '50px',
        color: '#4e4e4e',
      };

      return (
        <div>
          <Link to={this.props.to} style={{ display: 'inherit' }} activeClassName="selected">
            <ListItem
              primaryText={this.props.primaryText}
              leftIcon={this.props.leftIcon}
              innerDivStyle={this.props.innerDivStyle || listItemStyle}
              onClick={() => this.props.toggleMobileMenu(this.props.mobileMenuOpen)}
            />
          </Link>
        </div>
      );
    }
  }
);

class NavGroupItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opened: false,
    };
  }

  render() {
    const listItemStyle = {
      paddingLeft: '50px',
      color: '#4e4e4e',
      backgroundColor: this.state.opened ? colors.SIDEBAR_NESTED_GRAY : 'unset',
    };

    return (
      <ListItem
        id={'nav_grouped_item_' + this.props.primaryText}
        className="grouped_item"
        primaryText={this.props.primaryText}
        leftIcon={this.props.leftIcon}
        innerDivStyle={listItemStyle}
        primaryTogglesNestedList={true}
        nestedListStyle={{ padding: 0, background: colors.SIDEBAR_NESTED_GRAY }}
        onNestedListToggle={() => this.setState({ opened: !this.state.opened })}
        nestedItems={this.props.links.map((links) => (
          <NavLinkItem
            key={links['link_to']}
            to={links['link_to']}
            primaryText={links['primaryText']}
            leftIcon={links['leftIcon']}
            innerDivStyle={{}}
          />
        ))}
      />
    );
  }
}

const SideBar = connect((store) => {
  return {
    userPermissions: store.userTypes.permissions,
  };
})(
  class SideBar extends Component {
    shouldShowChild = (child) => {
      if (!this.props.userPermissions) {
        return true;
      }

      // Don't render a NavGroup if there are no valid children
      if (child.props.links) {
        const children = child.props.links.filter((link) =>
          authorizedRoute(link['link_to'], this.props.userPermissions)
        );

        return children.length !== 0;
      }

      return authorizedRoute(child.props.to, this.props.userPermissions);
    };

    render() {
      const children = this.props.children.filter(this.shouldShowChild);

      return (
        <nav className="left-nav-view">
          <div className="app-logo small-logo">
            <LandlordLogo maxWidth="137px" height="46px" marginTop="-1px" textHeight="27px" />
          </div>

          <div className="left-nav-list-view">
            <List style={{ padding: 0 }}>{children}</List>
          </div>

          <PoweredByYuhu />
        </nav>
      );
    }
  }
);

let MobileMenu = withMobileDialog()(
  connect(
    (store) => {
      return {
        userPermissions: store.userTypes.permissions,
        mobileMenuOpen: store.navigation.mobileMenuOpen,
      };
    },
    { toggleMobileMenu }
  )(
    class MobileMenu extends Component {
      constructor(props) {
        super(props);
        this.state = {
          open: false,
          current_query: browserHistory.getCurrentLocation().pathname,
        };
      }

      handleTouchTap = (event) => {
        // This prevents ghost click.
        event.preventDefault();
        this.setState({
          anchorEl: event.currentTarget,
        });
        this.props.toggleMobileMenu(this.props.mobileMenuOpen);
      };

      toggleMobileMenu = () => {
        this.props.toggleMobileMenu(this.props.mobileMenuOpen);
      };

      shouldShowChild = (child) => {
        if (!this.props.userPermissions) {
          return true;
        }

        // Don't render a NavGroup if there are no valid children
        if (child.props.links) {
          const children = child.props.links.filter((link) =>
            authorizedRoute(link['link_to'], this.props.userPermissions)
          );

          return children.length !== 0;
        }

        return authorizedRoute(child.props.to, this.props.userPermissions);
      };

      render() {
        const children = this.props.children.filter(this.shouldShowChild);
        const translateText = (text) => this.props.translate(text).props.children;

        return (
          <div>
            <Dialog
              fullScreen={this.props.fullScreen}
              open={this.props.mobileMenuOpen}
              onClose={this.toggleMobileMenu}
              aria-labelledby="mobile-menu"
            >
              <DialogTitle>
                <h3 style={{ textAlign: 'center', margin: 0 }}>
                  {translateText('landlordPortal.sideBar.menu')}
                </h3>
              </DialogTitle>
              <DialogContent>
                <div>{children}</div>
                <PoweredByYuhu />
              </DialogContent>
              <DialogActions style={{ display: 'block' }}>
                <FlatButton
                  label={translateText('landlordPortal.sideBar.close')}
                  style={{ color: AccentColor() }}
                  primary={true}
                  onClick={() => this.toggleMobileMenu()}
                />
              </DialogActions>
            </Dialog>

            <div className="mobile-menu">
              <h5
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginTop: 15,
                  fontFamily: 'Circular-Black',
                }}
                onClick={this.handleTouchTap}
              >
                <span>{translateText('landlordPortal.sideBar.viewMenu')}</span>

                <DownArrow size={18} />
              </h5>
            </div>
          </div>
        );
      }
    }
  )
);

MobileMenu = localize()(MobileMenu);

export { SideBar, NavLinkItem, NavGroupItem, MobileMenu };
